<script>
    import { section } from "../store/section.js";

    import { fetch_workspace_billing_info } from "../api/request.js";

    import { active_workspace } from "../store/workspace.js";
    import { active_subscription } from "../store/subscription.js";
    import { token } from "../store/token.js";
    import HeadingContent from "./component/HeadingContent.svelte";

    const set_section = (selected_section) => {
        section.set(selected_section);
    };

    const get_chargebee_invoice_object = async (invoice_id) => {
        const invoice_request_response = await fetch(
            `${process.env.API_ROOT}/workspace/${$active_workspace.string_id}/invoice/${invoice_id}/pdf`,
            {
                method: "get",
                headers: {
                    Authorization: "Bearer " + $token,
                    "control-workspace": $active_workspace.string_id,
                    "Content-Type": "application/json",
                },
            },
        );

        var invoice_object_json = await invoice_request_response.json();

        console.log(invoice_object_json);
        window.location.href = invoice_object_json.download.download_url;
    };
</script>

<div class="settings-holder settings-active">
    <!-- Settings Billing Overview (First Level) (the items of the menu of Security)-->
    <div class="settings-holder-content content-active">
        <HeadingContent
            title="Billing"
            back_button_enabled={true}
            back_button_click_action={() => {
                set_section("account/workspaces/overview");
            }}
        />
        <!--
        <div class="settings-heading">
            <div
                class="heading-block"
                on:click={() => {
                    set_section("account/workspaces/overview");
                }}
            >
                <a class="nav-opener" href="#"
                    ><i class="icon icon-navigation" /></a
                ><a class="nav-back" href="#">
                    <div class="ico-holder">
                        <i class="icon icon-chevron-left" />
                    </div>
                    <div class="title-holder">
                        <strong class="settings-title">Billing</strong>
                    </div></a
                >
            </div>
        </div>
        -->
        <div class="settings-content">
            <div class="settings-content-holder">
                <div class="card-h-100">
                    <div class="content-block">
                        <div
                            class="card-settings-main card bg-transparent-mobile"
                        >
                            <div class="card-body">
                                <nav>
                                    <ul class="nav-second-level nav-settings">
                                        <li
                                            on:click={() => {
                                                set_section(
                                                    "account/workspaces/overview/billing/plan",
                                                );
                                            }}
                                        >
                                            <a
                                                class="opener-third-level"
                                                href="#"
                                            >
                                                <div class="df-row df-aic gx-2">
                                                    <div class="col">
                                                        <div
                                                            class="opener-text"
                                                        >
                                                            <div
                                                                class="df-row df-jcb df-aic"
                                                            >
                                                                <div
                                                                    class="col"
                                                                >
                                                                    <strong
                                                                        class="nav-title"
                                                                        >Plan
                                                                        overview</strong
                                                                    >
                                                                    <div
                                                                        class="nav-text"
                                                                    >
                                                                        <p>
                                                                            Vollume
                                                                            -
                                                                            {$active_subscription
                                                                                .readable_super_short_title_mapping[
                                                                                $active_subscription
                                                                                    .plan_id
                                                                            ]}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="col-auto"
                                                                >
                                                                    <i
                                                                        class="icon icon-chevron-right"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div></a
                                            >
                                        </li>
                                        <li
                                            on:click={() => {
                                                set_section(
                                                    "account/workspaces/overview/billing/payment_methods",
                                                );
                                            }}
                                        >
                                            <a
                                                class="opener-third-level"
                                                href="#"
                                            >
                                                <div class="df-row df-aic gx-2">
                                                    <div class="col">
                                                        <div
                                                            class="opener-text"
                                                        >
                                                            <div
                                                                class="df-row df-jcb df-aic"
                                                            >
                                                                <div
                                                                    class="col"
                                                                >
                                                                    <strong
                                                                        class="nav-title"
                                                                        >Payment
                                                                        Methods</strong
                                                                    >
                                                                    <div
                                                                        class="nav-text"
                                                                    >
                                                                        <p></p>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="col-auto"
                                                                >
                                                                    <i
                                                                        class="icon icon-chevron-right"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div></a
                                            >
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                    <div class="content-block">
                        <h3 class="title-card-block text-white">
                            Billing History
                        </h3>
                        <div class="intro-text text-small">
                            <p>
                                Receipts from successful payments will appear
                                here.
                            </p>
                        </div>
                        <div
                            class="card-settings-main card bg-transparent-mobile"
                        >
                            <div class="card-body">
                                <nav>
                                    <ul class="nav-second-level nav-settings">
                                        {#each $active_subscription.raw.invoice_list as invoice}
                                            <li>
                                                <div class="opener-third-level">
                                                    <div
                                                        class="df-row df-aic gx-2"
                                                    >
                                                        <div class="col">
                                                            <div
                                                                class="opener-text"
                                                            >
                                                                <div
                                                                    class="df-row df-jcb df-aic"
                                                                >
                                                                    <div
                                                                        class="col"
                                                                    >
                                                                        <strong
                                                                            class="nav-title"
                                                                            >{$active_subscription
                                                                                .readable_super_short_title_mapping[
                                                                                $active_subscription
                                                                                    .plan_id
                                                                            ]}</strong
                                                                        >
                                                                        <div
                                                                            class="nav-text"
                                                                        >
                                                                            <p>
                                                                                ${invoice.total /
                                                                                    100}
                                                                                <time
                                                                                    datetime="2022-05-29"
                                                                                    >{new Date(
                                                                                        invoice.paid_at *
                                                                                            1000,
                                                                                    ).toLocaleDateString()}</time
                                                                                >
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="col-auto"
                                                                    >
                                                                        <div
                                                                            class="links-opener"
                                                                        >
                                                                            <div
                                                                                class="df-row df-aic gx-3"
                                                                            >
                                                                                <div
                                                                                    class="col-auto"
                                                                                >
                                                                                    <a
                                                                                        href="#"
                                                                                        on:click={() => {
                                                                                            get_chargebee_invoice_object(
                                                                                                invoice.id,
                                                                                            );
                                                                                        }}
                                                                                        >Invoice</a
                                                                                    >
                                                                                </div>
                                                                                <!--<div
                                                                                        class="col-auto"
                                                                                    >
                                                                                        <a
                                                                                            href="#"
                                                                                            >Receipt</a
                                                                                        >
                                                                                    </div>-->
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        {/each}
                                        <!--<li>
                                                <div class="opener-third-level">
                                                    <div
                                                        class="df-row df-aic gx-2"
                                                    >
                                                        <div class="col">
                                                            <div
                                                                class="opener-text"
                                                            >
                                                                <div
                                                                    class="df-row df-jcb df-aic"
                                                                >
                                                                    <div
                                                                        class="col"
                                                                    >
                                                                        <strong
                                                                            class="nav-title"
                                                                            >Pro
                                                                            200</strong
                                                                        >
                                                                        <div
                                                                            class="nav-text"
                                                                        >
                                                                            <p>
                                                                                $19.99
                                                                                <time
                                                                                    datetime="2022-05-29"
                                                                                    >May
                                                                                    29,
                                                                                    2022</time
                                                                                >
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="col-auto"
                                                                    >
                                                                        <div
                                                                            class="links-opener"
                                                                        >
                                                                            <div
                                                                                class="df-row df-aic gx-3"
                                                                            >
                                                                                <div
                                                                                    class="col-auto"
                                                                                >
                                                                                    <a
                                                                                        href="#"
                                                                                        >Invoice</a
                                                                                    >
                                                                                </div>
                                                                                <div
                                                                                    class="col-auto"
                                                                                >
                                                                                    <a
                                                                                        href="#"
                                                                                        >Receipt</a
                                                                                    >
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="opener-third-level">
                                                    <div
                                                        class="df-row df-aic gx-2"
                                                    >
                                                        <div class="col">
                                                            <div
                                                                class="opener-text"
                                                            >
                                                                <div
                                                                    class="df-row df-jcb df-aic"
                                                                >
                                                                    <div
                                                                        class="col"
                                                                    >
                                                                        <strong
                                                                            class="nav-title"
                                                                            >Pro
                                                                            200</strong
                                                                        >
                                                                        <div
                                                                            class="nav-text"
                                                                        >
                                                                            <p>
                                                                                $19.99
                                                                                <time
                                                                                    datetime="2022-05-29"
                                                                                    >May
                                                                                    29,
                                                                                    2022</time
                                                                                >
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="col-auto"
                                                                    >
                                                                        <div
                                                                            class="links-opener"
                                                                        >
                                                                            <div
                                                                                class="df-row df-aic gx-3"
                                                                            >
                                                                                <div
                                                                                    class="col-auto"
                                                                                >
                                                                                    <a
                                                                                        href="#"
                                                                                        >Invoice</a
                                                                                    >
                                                                                </div>
                                                                                <div
                                                                                    class="col-auto"
                                                                                >
                                                                                    <a
                                                                                        href="#"
                                                                                        >Receipt</a
                                                                                    >
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="opener-third-level">
                                                    <div
                                                        class="df-row df-aic gx-2"
                                                    >
                                                        <div class="col">
                                                            <div
                                                                class="opener-text"
                                                            >
                                                                <div
                                                                    class="df-row df-jcb df-aic"
                                                                >
                                                                    <div
                                                                        class="col"
                                                                    >
                                                                        <strong
                                                                            class="nav-title"
                                                                            >Pro
                                                                            200</strong
                                                                        >
                                                                        <div
                                                                            class="nav-text"
                                                                        >
                                                                            <p>
                                                                                $19.99
                                                                                <time
                                                                                    datetime="2022-05-29"
                                                                                    >May
                                                                                    29,
                                                                                    2022</time
                                                                                >
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="col-auto"
                                                                    >
                                                                        <div
                                                                            class="links-opener"
                                                                        >
                                                                            <div
                                                                                class="df-row df-aic gx-3"
                                                                            >
                                                                                <div
                                                                                    class="col-auto"
                                                                                >
                                                                                    <a
                                                                                        href="#"
                                                                                        >Invoice</a
                                                                                    >
                                                                                </div>
                                                                                <div
                                                                                    class="col-auto"
                                                                                >
                                                                                    <a
                                                                                        href="#"
                                                                                        >Receipt</a
                                                                                    >
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="opener-third-level">
                                                    <div
                                                        class="df-row df-aic gx-2"
                                                    >
                                                        <div class="col">
                                                            <div
                                                                class="opener-text"
                                                            >
                                                                <div
                                                                    class="df-row df-jcb df-aic"
                                                                >
                                                                    <div
                                                                        class="col"
                                                                    >
                                                                        <strong
                                                                            class="nav-title"
                                                                            >Pro
                                                                            200</strong
                                                                        >
                                                                        <div
                                                                            class="nav-text"
                                                                        >
                                                                            <p>
                                                                                $19.99
                                                                                <time
                                                                                    datetime="2022-05-29"
                                                                                    >May
                                                                                    29,
                                                                                    2022</time
                                                                                >
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="col-auto"
                                                                    >
                                                                        <div
                                                                            class="links-opener"
                                                                        >
                                                                            <div
                                                                                class="df-row df-aic gx-3"
                                                                            >
                                                                                <div
                                                                                    class="col-auto"
                                                                                >
                                                                                    <a
                                                                                        href="#"
                                                                                        >Invoice</a
                                                                                    >
                                                                                </div>
                                                                                <div
                                                                                    class="col-auto"
                                                                                >
                                                                                    <a
                                                                                        href="#"
                                                                                        >Receipt</a
                                                                                    >
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        -->
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--
    <div class="settings-holder-content">
        <div class="settings-heading">
            <div class="heading-block">
                <a class="nav-opener" href="#"
                    ><i class="icon icon-navigation" /></a
                ><a class="nav-back" href="#">
                    <div class="ico-holder">
                        <i class="icon icon-chevron-left" />
                    </div>
                    <div class="title-holder">
                        <strong class="settings-title">Plan overview</strong>
                    </div></a
                >
            </div>
        </div>
        <div class="settings-content">
            <div class="settings-content-holder">
                <div class="card-h-100">
                    <div
                        class="card-settings-main card-join-bottom card bg-transparent-mobile"
                    >
                        <div class="card-body">
                            <nav>
                                <ul class="nav-second-level nav-settings">
                                    <li>
                                        <div class="opener-third-level">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Your plan</strong
                                                                >
                                                                <div
                                                                    class="nav-text"
                                                                >
                                                                    <p>
                                                                        You are
                                                                        on the
                                                                        Free
                                                                        Starter
                                                                        plan
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="opener-third-level">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Riot Games
                                                                    Seat usage</strong
                                                                >
                                                                <div
                                                                    class="nav-text"
                                                                >
                                                                    <p>
                                                                        1 of 2
                                                                        users
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="opener-third-level">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Universal
                                                                    Music Seat
                                                                    usage</strong
                                                                >
                                                                <div
                                                                    class="nav-text"
                                                                >
                                                                    <p>
                                                                        1 of 2
                                                                        users
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="opener-third-level">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Storage
                                                                    usage</strong
                                                                >
                                                                <div
                                                                    class="nav-text"
                                                                >
                                                                    <p>
                                                                        8 of 20
                                                                        songs
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="col-auto"
                                                            >
                                                                <div
                                                                    class="links-opener"
                                                                >
                                                                    <div
                                                                        class="df-row df-aic gx-3"
                                                                    >
                                                                        <div
                                                                            class="col-auto"
                                                                        >
                                                                            <a
                                                                                href="#"
                                                                                >Manage
                                                                                plan</a
                                                                            >
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="opener-third-level">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Asset
                                                                    container
                                                                    storage
                                                                    usage</strong
                                                                >
                                                                <div
                                                                    class="nav-text"
                                                                >
                                                                    <p>
                                                                        8 of 20
                                                                        songs
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
                <div
                    class="card-settings-main-footer card bg-transparent-mobile"
                >
                    <div class="card-body">
                        <div class="df-row df-aic row-mobile-reverse gx-1">
                            <div class="col">
                                <p>
                                    Upgrade to Professional, Team or Enterprise
                                    for even more great features.
                                </p>
                            </div>
                            <div class="col-md-auto">
                                <a class="btn btn-primary" href="#"
                                    >Upgrade Plans</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="settings-holder-content">
        <div class="settings-heading">
            <div class="heading-block">
                <a class="nav-opener" href="#"
                    ><i class="icon icon-navigation" /></a
                ><a class="nav-back" href="#">
                    <div class="ico-holder">
                        <i class="icon icon-chevron-left" />
                    </div>
                    <div class="title-holder">
                        <strong class="settings-title">Plan overview</strong>
                    </div></a
                >
            </div>
        </div>
        <div class="settings-content">
            <div class="settings-content-holder">
                <div class="card-h-100">
                    <div
                        class="card-settings-main card-join-bottom card bg-transparent-mobile"
                    >
                        <div class="card-body">
                            <nav>
                                <ul class="nav-second-level nav-settings">
                                    <li>
                                        <div class="opener-third-level">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Your plan</strong
                                                                >
                                                                <div
                                                                    class="nav-text"
                                                                >
                                                                    <p>
                                                                        You are
                                                                        on the
                                                                        Pro 200
                                                                        plan
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="opener-third-level">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Riot Games
                                                                    Seat usage</strong
                                                                >
                                                                <div
                                                                    class="nav-text"
                                                                >
                                                                    <p>
                                                                        1 of 20
                                                                        users
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="opener-third-level">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Universal
                                                                    Music Seat
                                                                    usage</strong
                                                                >
                                                                <div
                                                                    class="nav-text"
                                                                >
                                                                    <p>
                                                                        1 of 20
                                                                        users
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="opener-third-level">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Storage
                                                                    usage</strong
                                                                >
                                                                <div
                                                                    class="nav-text"
                                                                >
                                                                    <p>
                                                                        80 of
                                                                        250GB
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="col-auto"
                                                            >
                                                                <div
                                                                    class="links-opener"
                                                                >
                                                                    <div
                                                                        class="df-row df-aic gx-3"
                                                                    >
                                                                        <div
                                                                            class="col-auto"
                                                                        >
                                                                            <a
                                                                                href="#"
                                                                                >Manage
                                                                                plan</a
                                                                            >
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="opener-third-level">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Asset
                                                                    container
                                                                    storage
                                                                    usage</strong
                                                                >
                                                                <div
                                                                    class="nav-text"
                                                                >
                                                                    <p>
                                                                        100 of
                                                                        250GB
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
                <div
                    class="card-settings-main-footer card bg-transparent-mobile"
                >
                    <div class="card-body">
                        <div class="df-row df-aic df-md-jce gx-1">
                            <div class="col-md-auto">
                                <a class="btn btn-dark" href="#">Change Plan</a>
                            </div>
                            <div class="col-md-auto">
                                <a class="btn btn-danger" href="#"
                                    >Disconnect Device</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="settings-holder-content">
        <div class="settings-heading">
            <div class="heading-block">
                <a class="nav-opener" href="#"
                    ><i class="icon icon-navigation" /></a
                ><a class="nav-back" href="#">
                    <div class="ico-holder">
                        <i class="icon icon-chevron-left" />
                    </div>
                    <div class="title-holder">
                        <strong class="settings-title">Plan overview</strong>
                    </div></a
                >
            </div>
        </div>
        <div class="settings-content">
            <div class="settings-content-holder">
                <div class="card-h-100">
                    <div
                        class="card-settings-main card-join-bottom card bg-transparent-mobile"
                    >
                        <div class="card-body">
                            <nav>
                                <ul class="nav-second-level nav-settings">
                                    <li>
                                        <div class="opener-third-level">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Card
                                                                    information</strong
                                                                >
                                                                <div
                                                                    class="nav-text"
                                                                >
                                                                    <p>
                                                                        American
                                                                        Express
                                                                        ending
                                                                        in 5678
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="opener-third-level">
                                            <div class="df-row df-aic gx-2">
                                                <div class="col">
                                                    <div class="opener-text">
                                                        <div
                                                            class="df-row df-jcb df-aic"
                                                        >
                                                            <div class="col">
                                                                <strong
                                                                    class="nav-title"
                                                                    >Invoice
                                                                    Settings</strong
                                                                >
                                                                <div
                                                                    class="nav-text"
                                                                >
                                                                    <p>
                                                                        Update
                                                                        your
                                                                        company
                                                                        info
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
                <div
                    class="card-settings-main-footer card bg-transparent-mobile"
                >
                    <div class="card-body">
                        <div class="df-row df-aic df-md-jce gx-1">
                            <div class="col-md-auto">
                                <a class="btn btn-dark" href="#"
                                    >Edit Invoice Information</a
                                >
                            </div>
                            <div class="col-md-auto">
                                <a class="btn btn-primary" href="#"
                                    >Update Card</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>-->
</div>
